/**
 * AI Entry Points - Auto-generated from Go source
 *
 * DO NOT EDIT - This file is auto-generated by magefiles/internal/gen/gen.go
 * Source: api/lambda/ai/models/api.go
 *
 * To add a new entry point:
 *   1. Add the constant to api/lambda/ai/models/api.go (EntryPoint* constants)
 *   2. Run 'mage gen:aiEntryPoints' to regenerate this file (or 'mage gen:all')
 *
 * The generator automatically extracts all constants with the "EntryPoint" name prefix.
 */

export const ENTRY_POINT_ALERT = 'alert';
export const ENTRY_POINT_ALERT_FORWARDER = 'alert-forwarder';
export const ENTRY_POINT_ALERT_LIST = 'alert-list';
export const ENTRY_POINT_DETECTION_AUTHOR = 'detection-author';
export const ENTRY_POINT_DETECTION_OVERVIEW = 'detection-overview';
export const ENTRY_POINT_DETECTION_TESTS = 'detection-tests';
export const ENTRY_POINT_DRILL_DOWN = 'drill-down';
export const ENTRY_POINT_EVENTS = 'events';
export const ENTRY_POINT_ORGANIZATION_PROFILE = 'organization-profile';
export const ENTRY_POINT_OVERVIEW = 'overview';
export const ENTRY_POINT_PANTHER_FLOW_QUERY = 'pantherflow-query';
export const ENTRY_POINT_REPLAY = 'replay';
export const ENTRY_POINT_RUNBOOK_AUTHOR = 'runbook-author';
export const ENTRY_POINT_SCHEDULED_PROMPT = 'scheduled-prompt';
export const ENTRY_POINT_SCHEMA_INFERENCE = 'schema-inference';
export const ENTRY_POINT_SEARCH = 'search';
export const ENTRY_POINT_SKILL_AUTHOR = 'skill-author';
export const ENTRY_POINT_SLACK_BUTTON = 'slack-button';
export const ENTRY_POINT_SLACK_MENTION = 'slack-mention';
export const ENTRY_POINT_SQL_QUERY_AUTHOR = 'sql-query-author';
